import {
  getSanitizeArticleFunc,
  getZendeskLocale,
} from "@faire/web--source/common/zendesk/utils";
import { useQuery as useZendeskArticleQuery } from "@faire/web-api--source/api/zendesk/locale/articles/articleId/get-hooks";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { useQuery } from "@tanstack/react-query";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";

import { TOSType } from "./data/consts";
import { getZendeskArticleData } from "./data/utils";

const sanitizePatterns = {
  "<p> </p>": "<br />",
};

export const useTosArticle = (tosType: TOSType) => {
  // TODO(Kim): FD-237254 Clean up post Insider AUS/CAN Expansion
  const { data: zendeskData, isPending: isLoadingZendeskData } = useQuery({
    queryKey: [tosType],
    queryFn: () => getZendeskArticleData(tosType),
  });

  const { data, isPending: isLoadingArticleData } = useZendeskArticleQuery(
    getZendeskLocale(getLocaleKey()?.language ?? Language.ENG),
    zendeskData?.linkOrId ?? "",
    undefined,
    { enabled: tosType === TOSType.OWF_GRANT ? !!zendeskData?.linkOrId : true }
  );

  const body = getSanitizeArticleFunc(sanitizePatterns)(
    data?.article?.body ?? ""
  );

  return { body, isLoading: isLoadingZendeskData || isLoadingArticleData };
};
